import { Link } from 'react-router-dom';

export default function CTACards() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-medium text-accent-600 tracking-wider uppercase whitespace-nowrap">
            Start Your Journey
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-900 mt-2">
            The <span className="italic font-heading text-primary-500">Spreadsheet</span> Revolution
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto leading-relaxed">
            Powerful automation tools designed for modern sourcing agents and e-commerce professionals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="relative bg-primary-500 rounded-lg p-8 md:p-10 group cursor-pointer overflow-hidden"
          >
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full cursor-pointer">
              <i className="ri-arrow-right-up-line text-white text-lg"></i>
            </div>
            <span className="text-5xl md:text-6xl font-heading font-bold text-white/20">01</span>
            <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mt-3">
              GTBuy Spreadsheet System
            </h3>
            <p className="text-white/80 text-sm mt-2 max-w-xs leading-relaxed">
              Complete automation toolkit for tracking orders, managing inventory, and optimizing your sourcing workflow.
            </p>
            <p className="text-white/60 italic text-sm mt-6 whitespace-nowrap">GTBUY SHEET</p>
          </a>

          <div className="relative bg-accent-500 rounded-lg p-8 md:p-10 group overflow-hidden">
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-shopping-bag-line text-white text-lg"></i>
            </div>
            <span className="text-5xl md:text-6xl font-heading font-bold text-white/20">02</span>
            <h3 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mt-3">
              Browse KASpreadsheet
            </h3>
            <p className="text-white/80 text-sm mt-2 max-w-xs leading-relaxed">
              Visit our main marketplace for the full product catalog, latest spreadsheet templates, and exclusive deals.
            </p>
            <Link
              to="/article/shopping-guide-kaspreadsheet"
              className="inline-flex items-center gap-1.5 mt-6 text-white/90 hover:text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Read Shopping Guide
              <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}